import {ParameterStore} from './ParameterStore';

const evalkidstrueGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.kids.value == (true as boolean);
};
const evaltobaccotrueGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.tobacco.value == (true as boolean);
};
const evalhealthConditionstrueGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.healthConditions.value == (true as boolean);
};
const evalcurrentlyEmployedEmployedGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.currentlyEmployed.value == 'Employed';
};
const evalprevEmployedGuard = (parameterStore: ParameterStore) => {
    const prequal = parameterStore.prequal;
    return (
        evalcurrentlyEmployedEmployedGuard(parameterStore) &&
        prequal.employmentDays.value != '' &&
        (prequal.employmentDays.value < 186 || prequal.timeEmployed.value <= 0.5)
    );
};
const evalcurrentlyEmployedUnemployedGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.currentlyEmployed.value == 'Unemployed';
};
const evalcurrentlyEmployedRetiredGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.currentlyEmployed.value == 'Retired';
};
const evalcurrentlyEmployedStudentGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.currentlyEmployed.value == 'Student';
};
const evalcurrentlyEmployedDisabilityGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.currentlyEmployed.value == 'Disability';
};
const evalexistingCoveragetrueGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.existingCoverage.value == true;
};
const evalshoppedCoveragetrueGuard = (parameterStore: ParameterStore) => {
    return parameterStore.prequal.shoppedCoverage.value == true;
};

export const prequalGuards = {
    kidsNumber: evalkidstrueGuard,
    tobaccoUsage: evaltobaccotrueGuard,
    tobaccoUsageDate: evaltobaccotrueGuard,
    tobaccoMethod: evaltobaccotrueGuard,
    otherHealthConditions: evalhealthConditionstrueGuard,
    currentSelfEmployed: evalcurrentlyEmployedEmployedGuard,
    nameOfEmployer: evalcurrentlyEmployedEmployedGuard,
    timeEmployed: evalcurrentlyEmployedEmployedGuard,
    employmentDays: evalcurrentlyEmployedEmployedGuard,
    employerAddress: evalcurrentlyEmployedEmployedGuard,
    occupation: evalcurrentlyEmployedEmployedGuard,
    industryDuties: evalcurrentlyEmployedEmployedGuard,
    prevSelfEmployed: evalprevEmployedGuard,
    prevEmployName: evalprevEmployedGuard,
    prevEmployStart: evalprevEmployedGuard,
    prevEmployOccup: evalprevEmployedGuard,
    prevEmployIndustry: evalprevEmployedGuard,
    reasonUnemployed: evalcurrentlyEmployedUnemployedGuard,
    previousJobInfo: evalcurrentlyEmployedUnemployedGuard,
    previousIncome: evalcurrentlyEmployedUnemployedGuard,
    retiredInfo: evalcurrentlyEmployedRetiredGuard,
    retiredIncome: evalcurrentlyEmployedRetiredGuard,
    schoolInfo: evalcurrentlyEmployedStudentGuard,
    disabilityInfo: evalcurrentlyEmployedDisabilityGuard,
    existingPolicyType: evalexistingCoveragetrueGuard,
    existingCarrier: evalexistingCoveragetrueGuard,
    existingCoverageAmount: evalexistingCoveragetrueGuard,
    shoppedPolicyType: evalshoppedCoveragetrueGuard,
    shoppedCarrier: evalshoppedCoveragetrueGuard,
    shoppedCoverageAmount: evalshoppedCoveragetrueGuard,
};
